module.exports = __webpack_public_path__ + "img/07.b0749a81.jpg";